// Please keep keys lowercase!
exports.supportedLanguages = {
  en: 'English',
  zh: '简体中文',
};
